import imageCompression from "browser-image-compression";

export const projectSurveyResult = (answers, userId) => {
  const registration = new Date().toISOString();
  const clientQuestionnaire =
    answers.clientQuestionnaire &&
    new Date(answers.clientQuestionnaire).toISOString();
  const neighborhoodSurvey =
    answers.neighborhoodSurvey &&
    new Date(answers.neighborhoodSurvey).toISOString();
  const propertyAssessment =
    answers.propertyAssessment &&
    new Date(answers.propertyAssessment).toISOString();

  return {
    status: "active",
    formData: answers,
    dates: {
      registrationDate: registration,
      clientQuestionnaireDueDate: clientQuestionnaire,
      neighborhoodSurveyDueDate: neighborhoodSurvey,
      propertyAssessmentDueDate: propertyAssessment,
    },
    aps: {
      primary: userId,
    },
    clientId: answers.clientId,
  };
};

export const clientSurveyResult = (answers) => {
  return {
    formData:answers,
    projectId: [],
    safeApId: "",
  };
};

export const setCurrentClient = (surveyModel, clientsArr) => {
  const currentClient = clientsArr[clientsArr.length - 1];

  surveyModel
    .getQuestionByName("clientId")
    .setPropertyValue("choices", clientsArr);

  surveyModel.setValue("clientId", currentClient.value);
  surveyModel.setValue("clientFirstName", currentClient.clientFirstName);
  surveyModel.setValue("clientLastName", currentClient.clientLastName);
  surveyModel.setValue("clientAddress", currentClient.clientAddress);
  surveyModel.setValue(
    "clientZipPostalCode",
    currentClient.clientZipPostalCode
  );
  surveyModel.setValue("clientCity", currentClient.clientCity);
  surveyModel.setValue(
    "clientStateProvince",
    currentClient.clientStateProvince
  );
  surveyModel.setValue("clientCountry", currentClient.clientCountry);
  surveyModel.setValue("clientEmail", currentClient.clientEmail);
  surveyModel.setValue("clientPhone", currentClient.clientPhone);
};

export const toBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

export const handleImageUpload = async (imageFile) => {
  const options = {
    maxSizeMB: 0.4,
    maxWidthOrHeight: 1080,
    useWebWorker: true,
  };
  try {
    const compressedFile = await imageCompression(imageFile, options);

    return compressedFile;
    // await uploadToServer(compressedFile); // write your own logic
  } catch (error) {}
};
